{
  "login-secret-with-pin-page": {
    "buttons": {
      "resend": "Erneut senden",
      "submit": "Einreichen"
    },
    "text": {
      "in-second": "in {{seconds}} s",
      "pin-email-invalid": "Die PIN ist ungültig. Bitte überprüfen Sie sie in Ihrer E-Mail und versuchen Sie es erneut.",
      "pin-sms-invalid": "Die PIN ist ungültig. Bitte überprüfen Sie sie in Ihrer SMS und versuchen Sie es erneut.",
      "resend-pin-hint": "Sie haben keine PIN erhalten?",
      "verify-email": "Überprüfen Sie Ihre E-Mail",
      "verify-phone-nr": "Überprüfen Sie Ihre Telefonnummer",
      "verify-update": "Überprüfen Sie Ihre Aktualisierung",
      "verify-update-by-email": "Sie erhalten eine Bestätigungsnummer per E-Mail",
      "verify-update-by-sms": "Sie erhalten eine Bestätigungsnummer per SMS"
    }
  }
}
